define( function() {
	"use strict";

	return ( /^$|^module$|\/(?:java|ecma)script/i );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/manipulation/var/rscriptType.js
// module id = 695
// module chunks = 0